<div class="container">
    <div class="login">
        <div class="wrapper">
            <div class="row g-0">
                <div class="col-5">
                    <div class="image-wrapper">
                    </div>
                </div>
                <div class="col-7">
                    @if(isTestServer) {
                        <div class="tst-hint">
                            <div class="wrapper">
                                <div class="row">
                                    <div class="col-12">
                                        <h3>{{'testServer.hl' |translate}}</h3>
                                        <p>{{'testServer.description' | translate}}</p>
                                        <a [href]="prdDomain" target="_blank">{{prdDomain}}</a>
                                    </div>
                                </div>
                            </div>

                        </div>
                    }
                    @if(state === ResetState.init) {
                        <div class="form-wrapper">
                            <div class="row ">
                                <div class="col-12">
                                    <div class="logo-wrapper">
                                        <div class="logo"></div>
                                    </div>

                                </div>
                            </div>
                            <div class="row ">
                                <div class="col-12">
                                    <h2>{{'reset.headline.init' |translate}}</h2>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <form [formGroup]="emailForm" (ngSubmit)="sendEmail()">
                                         <div class="login-form">
                                             <div class="row">
                                                 <div class="col-12">
                                                     <mat-form-field>
                                                         <mat-label>{{'login.email' | translate}}</mat-label>
                                                         <input matInput type="text" formControlName="email" aria-describedby="emailRequired emailInvalid">
                                                     </mat-form-field>
                                                     @if(emailForm.controls['email'].invalid && (emailForm.get('email')?.touched)) {
                                                         @if(emailForm.controls['email'].hasError('required')) {
                                                             <div class="error" id="emailRequired" role="alert">{{'error.required' | translate}}</div>
                                                         }
                                                         @if(emailForm.controls['email'].hasError('email')) {
                                                             <div class="error" id="emailInvalid" role="alert">{{'error.emailInvalid' | translate}}</div>
                                                         }
                                                     }
                                                 </div>
                                             </div>
                                             @if(errorMessage) {
                                                 <div class="row mt-3">
                                                     <div class="col-12">
                                                         <p><span class="error">{{errorMessage | translate}}</span></p>
                                                     </div>
                                                 </div>
                                             }
                                             <div class="row">
                                                 <div class="col-12">
                                                     <a routerLink="/login">{{'backToLogin' | translate}}</a>
                                                     <button mat-raised-button type="submit"  [disabled]="!emailForm.valid" class="button float-end" >{{'button.send' | translate}}</button>
                                                 </div>
                                             </div>
                                         </div>
                                     </form>
                                </div>
                            </div>
                        </div>
                    }
                    @if(state === ResetState.code) {
                        <div class="form-wrapper">
                            <div class="row ">
                                <div class="col-12">
                                    <div class="logo-wrapper">
                                        <div class="logo"></div>
                                    </div>

                                </div>
                            </div>
                            <div class="row ">
                                <div class="col-12">
                                    <h2>{{'reset.headline.code' |translate}}</h2>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <form [formGroup]="codeForm" (ngSubmit)="sendCode()">
                                        <div class="login-form">
                                            <div class="row">
                                                <div class="col-12">
                                                    <mat-form-field>
                                                        <mat-label>{{'login.email' | translate}}</mat-label>
                                                        <input matInput type="text" formControlName="email">
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12">
                                                    <mat-form-field>
                                                        <mat-label>{{'login.code' | translate}}</mat-label>
                                                        <input matInput type="text" formControlName="code" aria-describedby="codeRequiered">
                                                    </mat-form-field>
                                                    @if(codeForm.controls['code'].invalid && (codeForm.get('code')?.touched)) {
                                                        @if(codeForm.controls['code'].hasError('required')) {
                                                            <div class="error" id="codeRequired" role="alert">{{'error.required' | translate}}</div>
                                                        }
                                                    }
                                                </div>
                                            </div>
                                            @if(errorMessage) {
                                                <div class="row mt-3">
                                                    <div class="col-12">
                                                        <p><span class="error">{{errorMessage |translate}}</span></p>
                                                    </div>
                                                </div>
                                            }
                                            <div class="row">
                                                <div class="col-12">
                                                    <div class="btn-row">
                                                        <button mat-button type="button" (click)="goBackEmail()">{{'button.back' |translate}}</button>
                                                        <button mat-raised-button type="submit"  [disabled]="!codeForm.valid" class="button float-end" >{{'button.send' | translate}}</button>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    }
                    @if(state === ResetState.setPassword) {
                        <div class="form-wrapper">
                            <div class="row ">
                                <div class="col-12">
                                    <div class="logo-wrapper">
                                        <div class="logo"></div>
                                    </div>

                                </div>
                            </div>
                            <div class="row ">
                                <div class="col-12">
                                    <h2>{{'reset.headline.password' |translate}}</h2>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <form [formGroup]="pwForm" (ngSubmit)="sendPassword()">
                                        <div class="login-form">
                                            <div class="row">
                                                <div class="col-12">
                                                    <mat-form-field>
                                                        <mat-label>{{'login.email' | translate}}</mat-label>
                                                        <input matInput type="text" formControlName="email">
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12">
                                                    <mat-form-field>
                                                        <mat-label>{{'login.code' | translate}}</mat-label>
                                                        <input matInput type="text" formControlName="code">
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12">
                                                    <mat-form-field>
                                                        <mat-label>{{'login.password' | translate}}</mat-label>
                                                        <input matInput type="password" formControlName="password">
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="passMeter" [ngClass]="currentStrength">
                                               <span>{{'login.passwordStrength' | translate}} {{currentStrength | translate}}</span>
                                                <span>@if(currentStrength !== PasswordStrength.STRENGTH_VERY_WEAK) {
                                                    <mat-icon fontIcon="check"></mat-icon>
                                                }</span>
                                            </div>
                                            <div class="row">
                                                <div class="col-12">
                                                    <mat-form-field>
                                                        <mat-label>{{'login.password2' | translate}}</mat-label>
                                                        <input matInput type="password" formControlName="password2" aria-describedby="mustMatch">
                                                    </mat-form-field>
                                                    @if(pwForm.controls['password2'].invalid && (pwForm.get('password2')?.touched)) {
                                                        @if(pwForm.controls['password2'].errors?.['confirmedValidator']) {
                                                            <div class="error" id="mustMatch" role="alert">{{'error.noMatch' | translate}}</div>
                                                        }
                                                    }
                                                </div>
                                            </div>
                                            @if(errorMessage) {
                                                <div class="row mt-3">
                                                    <div class="col-12">
                                                        <p><span class="error">{{errorMessage | translate}}</span></p>
                                                    </div>
                                                </div>
                                            }
                                            <div class="row">
                                                <div class="col-12">
                                                    <button mat-raised-button type="submit"  [disabled]="!pwForm.valid || currentStrength === PasswordStrength.STRENGTH_VERY_WEAK" class="button float-end" >{{'button.send' | translate}}</button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    }

                </div>
            </div>
        </div>
    </div>
</div>
